import { render, staticRenderFns } from "./RemuneracaoValidacaoEGeracaoRightNavBar.vue?vue&type=template&id=bf11b4ee"
import script from "./RemuneracaoValidacaoEGeracaoRightNavBar.vue?vue&type=script&lang=ts"
export * from "./RemuneracaoValidacaoEGeracaoRightNavBar.vue?vue&type=script&lang=ts"
import style0 from "./RemuneracaoValidacaoEGeracaoRightNavBar.vue?vue&type=style&index=0&id=bf11b4ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports